import * as React from 'react';
import { ClientUrlUtils } from 'client/shared/core/helpers';
import './styles.scss';

const baseClass = 'pn-embed-publisher';

interface Props {
  readonly pubLogo: string | null;
  readonly pubName: string;
  readonly pubSlug: string;
}

export const EmbedPublisher: React.FC<Props> = (p) => {
  return (
    <div className={`${baseClass} d-flex flex-row mx-3 py-2`}>
      {p.pubLogo && (
        <img
          alt="Profile"
          className={`${baseClass}-profile-logo my-1 mr-3`}
          src={p.pubLogo}
        />
      )}
      <div className={`${baseClass}-posted-info font-size-sm d-felx flex-column`}>
        <div className={`${baseClass}-posted-label`}>Posted By</div>
        <div className={`${baseClass}-profile-name`}>
          <a
            href={ClientUrlUtils.respondent.pubProfile.url({
              slug: p.pubSlug,
            })}
            target="_blank"
          >
            {p.pubName}
          </a>
        </div>
      </div>
    </div>
  );
};
EmbedPublisher.displayName = 'EmbedPublisher';
